<template>
  <div id="contenedor-listado-mobiles">
    <template v-for="(contrato, index) in listadoContratos">
      <v-card :key="index" class="mb-2">
        <v-card-title class="justify-space-between">
          <div class="d-inline-block text-truncate">
            <router-link
              :to="{ name: 'contratoEjecucionGenerales', params: { idContrato: contrato.id } }"
              >
              {{ contrato.numero }}
        </router-link>
          </div>
          <div class="d-inline-block">
            <opciones :id="contrato.id"></opciones>
          </div>
        </v-card-title>
        <v-card-text>
          <cortar-texto
          :texto="contrato.meta"
          :cantidadCaracteres="cantidadCaracteresTexto">
          </cortar-texto>
        </v-card-text>
        <v-card-actions>
          <span class="mr-2">
          <v-chip
            small
            :disabled="contrato.cantidadEstimaciones <= 0"
            :class="contrato.cantidadEstimaciones > 0 ? 'success' : 'warning'">
            #Estimaciones: {{ contrato.cantidadEstimaciones }}
          </v-chip>
        </span>
          <template v-if="contrato.ultimoReporte">
            <v-chip
              small
              color="azul1">
              Avance: {{ contrato.ultimoReporte.avanceFisico }}%
            </v-chip>
          </template>
          <template v-else>
            <v-chip
              small
              color="azul1">
              Avance: 0%
            </v-chip>
          </template>
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import CortarTexto from '@/components/CortarTextos.vue';
import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoContratos: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    CortarTexto,
  },
  data() {
    return {
      cantidadCaracteresTexto: 100,
    };
  },
};
</script>

<style lang="scss">

</style>
